import { STORAGE_KEYS } from "../constants/userConstant";
import React, { createContext, useContext, useEffect, useReducer } from "react";
import CartReducer from "../reducer/cartreducer";
import { getCartDetails } from "../services/cartService";

export const CartContext = createContext();

const initialState = {
  items: [],
};

const CartProvider = ({ children }) => {
  const initialCart = JSON.parse(localStorage.getItem(STORAGE_KEYS.CART)) || initialState;
  const [state, dispatch] = useReducer(CartReducer, initialCart);

  const fetchCart = async (guestUserId = null) => {
    try {
      // Fetch cart for both logged-in users and guest users
      // If guestUserId is provided, pass it to API (used during cart sync)
      const response = await getCartDetails(guestUserId);
      const data = response.data;

      if (response) {
        dispatch({ type: "SET_CART", payload: data });
        localStorage.setItem(STORAGE_KEYS.CART, JSON.stringify({ items: data }));
      }
    } catch (error) {
      console.error("Failed to fetch cart:", error);
    }
  };

  useEffect(() => {
    // Only fetch cart on initial mount
    // Don't fetch on token changes - login/signup flows handle cart sync via syncGuestCart()
    fetchCart();
  }, []); // Empty dependency array - only run on mount

  return (
    <CartContext.Provider value={{ state, dispatch, fetchCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);

export default CartProvider;
